import React, { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import Checkbox, {
  CheckboxCustomProps,
} from '~/components/atoms/inputs/Checkbox';

const HookFormTextField: FC<CheckboxCustomProps & { name: string }> = ({
  name,
  ...props
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value },
        fieldState: { error },
      }): JSX.Element => (
        <Checkbox
          checked={value}
          onChange={onChange}
          errorMessage={error && error.message ? error.message : undefined}
          {...props}
        />
      )}
    />
  );
};

export default HookFormTextField;
